'use strict';

exports.__esModule = true;
exports.loaders = exports.dynamicArgumentsMap = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _doctifyGlobalRedux = require('doctify-global-redux');

var _doctifyGlobalRedux2 = _interopRequireDefault(_doctifyGlobalRedux);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _doctifyUtils = require('doctify-utils');

var _utils = require('./utils');

var _resultsActions = require('../actions/results-actions');

var _advancedSearchBarActions = require('../actions/advanced-search-bar-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getInsurers = _doctifyGlobalRedux2.default.globalActions.ListingsActions.getInsurers;
var getLanguages = _doctifyGlobalRedux2.default.globalActions.ListingsActions.getLanguages;
var getConditions = _doctifyGlobalRedux2.default.globalActions.ListingsActions.getConditions;
var getProcedures = _doctifyGlobalRedux2.default.globalActions.ListingsActions.getProcedures;
var getSpecialties = _doctifyGlobalRedux2.default.globalActions.ListingsActions.getSpecialties;
var getTreatmentGroups = _doctifyGlobalRedux2.default.globalActions.ListingsActions.getTreatmentGroups;
var getHealthChecks = _doctifyGlobalRedux2.default.globalActions.ListingsActions.getHealthChecks;
var getSpecialists = _doctifyGlobalRedux2.default.globalActions.ListingsActions.getSpecialists;
var getPractices = _doctifyGlobalRedux2.default.globalActions.ListingsActions.getPractices;

var flattenApiResponse = function flattenApiResponse(apiResponse) {
	var flatResponse = {};

	(0, _keys2.default)(apiResponse).forEach(function (key) {
		if ((0, _keys2.default)(apiResponse[key]).length === 1) {
			flatResponse[key] = apiResponse[key][(0, _keys2.default)(apiResponse[key])[0]];
		}
	});

	return flatResponse;
};

var searchCall = function searchCall(query, xhrConfig) {
	if (!query || !xhrConfig) {
		return function () {};
	}
	return function (dispatch) {
		return _bluebird2.default.props({
			insurers: getInsurers(xhrConfig)(dispatch),
			languages: getLanguages(xhrConfig)(dispatch),
			// conditions: getConditions(xhrConfig)(dispatch),
			// procedures: getProcedures(xhrConfig)(dispatch),
			specialties: getSpecialties(xhrConfig)(dispatch)
			// scansTreatmentGroups: getTreatmentGroups('scan', xhrConfig)(dispatch),
			// healthChecksTreatmentGroups: getTreatmentGroups('health_check', xhrConfig)(dispatch),
			// healthChecks: getHealthChecks(xhrConfig)(dispatch)
		}).then(function (result) {
			var flattenedResult = flattenApiResponse(result);
			return (0, _doctifyUtils.searchQueryParser)(query, flattenedResult).then(function (parsedQuery) {
				if (parsedQuery && parsedQuery.query && parsedQuery.query.selectedKeyword) {
					dispatch(_advancedSearchBarActions.advancedSearchBarActions.onKeywordSelected(parsedQuery.query.selectedKeyword));
				}
				if (parsedQuery && parsedQuery.query && parsedQuery.query.selectedKeyword && parsedQuery.query.selectedKeyword.name) {
					dispatch(_advancedSearchBarActions.advancedSearchBarActions.updateText(parsedQuery.query.selectedKeyword.name));
				} else if (parsedQuery && parsedQuery.query && parsedQuery.query.selectedHealthCheck) {
					dispatch(_advancedSearchBarActions.advancedSearchBarActions.updateText(parsedQuery.query.selectedHealthCheck));
				}
				return dispatch(_resultsActions.resultsActions.updateResults((0, _utils.buildSearchParameters)((0, _extends3.default)({}, parsedQuery.query, { listings: flattenedResult })), parsedQuery.query.searchType, flattenedResult, parsedQuery.query.network, xhrConfig)).then(function () {
					return _bluebird2.default.resolve();
				});
			});
		});
	};
};

var dynamicArgumentsMap = exports.dynamicArgumentsMap = {
	_query_: 'query',
	_useragent_: 'headers[\'user-agent\']'
};

var loaders = exports.loaders = [{
	key: 'listings.insurers',
	action: getInsurers,
	loadOnlyClientSide: true
}, {
	key: 'listings.languages',
	action: getLanguages,
	loadOnlyClientSide: true
}, {
	key: 'listings.specialists',
	action: getSpecialists,
	loadOnlyClientSide: true
}, {
	key: 'listings.specialties',
	action: getSpecialties,
	loadOnlyClientSide: true
},
// {
// 	key: 'listings.healthChecksTreatmentGroups',
// 	action: getTreatmentGroups,
// 	arguments: ['heath_check'],
// 	loadOnlyClientSide: true
// },
// {
// 	key: 'listings.scansTreatmentGroups',
// 	action: getTreatmentGroups,
// 	arguments: ['scan'],
// 	loadOnlyClientSide: true
// },
{
	key: 'listings.conditions',
	action: getConditions,
	loadOnlyClientSide: true
}, {
	key: 'listings.procedures',
	action: getProcedures,
	loadOnlyClientSide: true
},
// {
// 	key: 'listings.healthChecks',
// 	action: getHealthChecks,
// 	loadOnlyClientSide: true
// },
{
	key: 'results.searchResults',
	action: searchCall,
	arguments: ['_query_'],
	dynamicArguments: ['_query_'],
	loadGooglebotOnly: true
}];


// WEBPACK FOOTER //
// ./components/search-page/lib/utils/loaders.js